<template>
  <div class="main-content">
    <cargo-ag-grid
      :grid-options="gridOptions"
      :column-defs="columnDefs"
      :row-data="rowData"
      style="height: 100%;min-height: 200px;"
      @gridReady="params=>{gridApi=params.api}"
    />
    <div v-show="showButtons" style="display: flex;margin-top: 5px;">
      <el-button type="primary" @click="selectHandler">{{ $t('SeaExport.SelectFile') }}</el-button>
      <el-button type="primary" @click="deleteHandler">{{ $t('SeaExport.DeleteFile') }}</el-button>
    </div>
    <!-- 文件选择框 -->
    <el-upload
      v-show="false"
      action
      multiple
      :auto-upload="false"
      :show-file-list="false"
      :on-change="toChooseFile"
    >
      <el-button ref="uploadBtn" />
    </el-upload>
    <!-- 文档类别弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="docTypeTree.visible"
      :title="$t('SeaExport.Edit')"
      width="400px"
      :close-on-click-modal="false"
      class="app-main-inner"
      append-to-body
    >
      <div class="app-main-inner-row">
        <cargo-ag-grid
          :show-side-bar="false"
          :grid-options="docTypeTree.gridOptions"
          :row-data="docTypeTree.rowData||[]"
          style="width: 350px;height: 300px;padding-left: 2px;"
          @gridReady="params=>{docTypeTree.gridApi=params.api}"
        />
      </div>
      <span slot="footer" style="padding-right: 30px">
        <el-button type="primary" @click="saveDocType()">{{ $t('common.btn.ok') }}</el-button>
        <el-button @click="docTypeTree.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment'
import { AutoIncrementNum, DocumentManage, ensureExecuteSuccess } from '@/utils/commonUtil'
import { cache, cacheName } from '@/utils/cacheManager'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import * as DocumentConstants from '@/class/cargo/model/parameters/DocumentConstants'
import { getDocCategoryTypeTreeByLob } from '@/api/sysManage/baseConfig/docCategory'
import { getJobByUuid } from '@/api/booking/job'
import { getBusinessDocumentList, saveBusinessDocument, delBusinessDocument } from '@/api/businessDocument'
import { uploadStorage } from '@/api/storage'
import URL from '@/api/urlTranslator'

export default {
  name: 'WarehousePicGrid',
  props: {
    model: { type: Object, required: true },
    category: { type: Number, default: DocumentConstants.WAREHOUSE_PIC },
    showButtons: { type: Boolean, default: true },
    enableDeleteOldPic: { type: Boolean, default: true }
  },
  data() {
    return {
      user: this.$store.getters.userInfo,
      storageURL: '',
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        }
      },
      columnDefs: [
        {
          headerName: '',
          headerCheckboxSelection: true,
          checkboxSelection: true,
          width: 55,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        }, {
          headerName: this.$t('SeaExport.FileName'),
          colId: 'fileName',
          field: 'fileName',
          width: 175,
          cellRenderer: params => {
            if (params.data.documentId) {
              return `<a href="${URL.common.findByFileId}/${params.data.documentId}?sessionId=${this.user.sessionId}" target="_blank" style="color:#46a6ff">${params.value}</a>`
            }
            return params.value
          }
        }, {
          headerName: this.$t('SeaExport.FileType'),
          colId: 'fileType',
          field: 'fileType',
          width: 90
        }, {
          headerName: this.$t('SeaExport.FileSize'),
          colId: 'fileSize',
          field: 'fileSize',
          width: 90,
          cellRenderer: params => {
            return params.value ? (params.value / 1024).toFixed(1) + 'KB' : ''
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_UploadTime'),
          colId: 'dateCreated',
          field: 'dateCreated',
          width: 180
        },
        {
          headerName: this.$t('SeaExport.DocumentType'),
          colId: 'fileCategoryLabel',
          field: 'fileCategoryLabel',
          width: 115,
          cellRenderer: params => {
            const methodPath = this.documentManage.getPath('showDocTypeTree')
            return `<div onclick="${methodPath}(${params.data.seq})" style="cursor:pointer">${params.value || '&nbsp;'}</div>`
          }
        }, {
          headerName: this.$t('SeaExport.UploadProgress'),
          colId: 'uuid',
          field: 'uuid',
          width: 90,
          cellRenderer: params => {
            if (params.data.uuid || params.data.documentId) {
              return '<span style="color: #67C23A;">' + this.$t('Message.Uploaded') + '</span>'
            }
            if (this.uploading) {
              return this.$t('queryJob.uploading') + '...'
            }
            return this.$t('Message.Waiting')
          }
        }
      ],
      gridApi: null,
      uploading: false,
      autoIncrementNum: new AutoIncrementNum(),
      documentManage: new DocumentManage(),
      docTypeTree: {
        visible: false,
        gridOptions: {
          // 自行实现多选
          // rowSelection: 'multiple',
          groupDefaultExpanded: 0,
          suppressRowClickSelection: true,
          treeData: true,
          getDataPath: data => {
            return data.path.split(',')
          },
          autoGroupColumnDef: {
            headerName: this.$t('SeaExport.DocumentType'),
            width: 320,
            suppressMenu: true,
            cellRendererParams: {
              suppressDoubleClickExpand: true,
              innerRenderer: params => {
                if (params.data.type === 2) {
                  const iconName = params.data.checked ? 'checkbox-checked' : 'checkbox-notChecked'
                  return `<svg class="svg-icon" aria-hidden="true" style="height:1.2em;width:1.2em;vertical-align:text-bottom;">
                            <use xlink:href="#icon-${iconName}"></use>
                          </svg>
                          &nbsp;${params.data.chineseName}`
                }
                return params.data.chineseName
              }
            },
            onCellClicked: params => {
              if (params.data.type === 2) {
                const checked = !params.data.checked
                params.data.checked = checked
                params.api.refreshCells({ force: true })
              }
            }
          },
          columnDefs: [],
          context: {
            componentParent: this
          }
        },
        rowData: null,
        gridApi: null
      },
      docTypeMap: null
    }
  },
  computed: {
    rowData() {
      return this.model.business_Document ? this.model.business_Document.filter(p => p.todo !== 'remove') : []
    }
  },
  created() {
    this.buildDocTypeTree()
  },
  beforeMount() {
    const self = this
    this.documentManage.set('showDocTypeTree', function(seq) {
      self.showDocTypeTree(seq)
    })
  },
  beforeDestroy() {
    this.documentManage.destory()
  },
  methods: {
    // 初始化
    async init(addedBusinessDocuments = null) {
      await cache.load(cacheName.CONFIG)
      this.storageURL = cache.config.get('StorageURL')
      // 查询条件
      let params = null
      if (this.model.uuid) {
        if (!this.model.job && this.model.jobUuid) { // 获取job
          getJobByUuid(this.model.jobUuid).then(res => {
            this.model.job = res.data
          })
        }
        switch (this.category) {
          case DocumentConstants.WAREHOUSE_PIC:
            params = { warehouseInUuid: this.model.uuid }
            break
          case DocumentConstants.LOADING_PIC:
            params = { airExportFlightCustomerUuid: this.model.uuid }
            break
        }
      }
      if (params) {
        const loading = getLoading4Cxt(this)
        getBusinessDocumentList(params).then(async res => {
          await ensureExecuteSuccess(() => Boolean(this.docTypeMap))
          for (const item of res.data) {
            item.seq = this.autoIncrementNum.getNextNum()
            if (item.fileCategory) {
              const fileCategories = item.fileCategory.split(',')
              const fileCategoryLabels = []
              for (const category of fileCategories) {
                fileCategoryLabels.push(this.docTypeMap.get(category.toUpperCase()))
              }
              item.fileCategoryLabel = fileCategoryLabels.join(',')
            } else {
              item.fileCategoryLabel = ''
            }
          }
          this.model.business_Document = res.data
          if (addedBusinessDocuments) {
            this.model.business_Document.push(...addedBusinessDocuments)
            addedBusinessDocuments = null
          }
        }).catch(() => {
          this.model.business_Document = []
        }).finally(() => {
          loading.close()
        })
      } else {
        this.model.business_Document = []
      }
      if (addedBusinessDocuments) {
        this.model.business_Document.push(...addedBusinessDocuments)
      }
      if (!this.docTypeTree.rowData) {
        this.buildDocTypeTree()
      }
    },
    async buildDocTypeTree() {
      getDocCategoryTypeTreeByLob({ constructLobParent: false, lob: 'SE' }).then(res => {
        const data = res.data.filter(p => {
          const pathArr = p.path.split(',')
          if (p.type === 1) {
            return pathArr.length === 1
          }
          if (p.type === 2) {
            return pathArr.length > 1
          }
          return false
        })
        this.docTypeMap = new Map()
        data.forEach(item => {
          item.checked = false
          if (item.type === 2) {
            this.docTypeMap.set(item.code.toUpperCase(), item.chineseName)
          }
        })
        this.docTypeTree.rowData = data
      })
    },
    showDocTypeTree(seq) {
      const rows = this.rowData.filter(p => p.seq === seq)
      if (rows.length === 0) {
        return
      }
      const fileCategory = rows[0].fileCategory.toUpperCase()
      const fileCategories = fileCategory ? fileCategory.split(',') : []
      if (!this.docTypeTree.rowData) {
        return
      }
      this.docTypeTree.rowData.forEach(item => {
        if (fileCategories.length > 0 && fileCategories.includes(item.code.toUpperCase())) {
          item.checked = true
        } else {
          item.checked = false
        }
      })
      if (this.docTypeTree.gridApi) {
        this.docTypeTree.gridApi.setRowData(this.docTypeTree.rowData)
      }
      this.docTypeTree.visible = true
    },
    saveDocType() {
      const cell = this.gridApi.getFocusedCell()
      const currentRow = cell ? this.rowData[cell.rowIndex] : null
      const docTypeRows = this.docTypeTree.rowData.filter(p => p.type === 2 && p.checked)
      if (docTypeRows.length > 0) {
        let codes = ''
        let labels = ''
        for (const item of docTypeRows) {
          if (codes) {
            codes += ','
          }
          codes += item.code
          if (labels) {
            labels += ','
          }
          labels += item.chineseName
        }
        currentRow.fileCategory = codes
        currentRow.fileCategoryLabel = labels
      } else {
        currentRow.fileCategory = ''
        currentRow.fileCategoryLabel = ''
      }
      this.gridApi.refreshCells({ force: true })
      this.docTypeTree.visible = false
    },
    selectHandler() {
      this.$refs.uploadBtn.$el.click()
    },
    toChooseFile(file) {
      if (file.size > 2 * 1024 * 1024) {
        this.$message.warning(this.$t('queryJob.oneFileVolumn2MB'))
        return
      }
      const fileName = file.name
      const fileType = fileName.substr(fileName.lastIndexOf('.') + 1)
      this.model.business_Document.push({
        seq: this.autoIncrementNum.getNextNum(),
        uuid: '',
        documentId: '',
        documentCategory: this.category,
        fileName,
        fileType,
        fileSize: file.size,
        createdBy: this.user.userId,
        dateCreated: '',
        businessId: this.businessId,
        fileCategory: '',
        warehouseInUuid: this.category === DocumentConstants.WAREHOUSE_PIC ? this.model.uuid : '',
        airExportFlightCustomerUuid: this.category === DocumentConstants.LOADING_PIC ? this.model.uuid : '',
        file: file.raw,
        todo: 'new'
      })
    },
    deleteHandler() {
      const cell = this.gridApi.getFocusedCell()
      const row = cell ? this.rowData[cell.rowIndex] : null
      if (!row) {
        return
      }
      if (row.uuid && !this.enableDeleteOldPic) {
        return
      }
      if (row.uuid) {
        row.todo = 'remove'
        this.model.business_Document = [...this.model.business_Document]
      } else {
        const index = this.model.business_Document.findIndex(p => p.seq === row.seq)
        if (index >= 0) {
          this.model.business_Document.splice(index)
        }
      }
    },
    upload() {
      const uploadRows = this.model.business_Document.filter(p => p.todo === 'new' && !p.documentId)
      if (uploadRows.length === 0) {
        this.$emit('uploadDone')
        return
      }
      const parameters = {}
      if (this.model.job) {
        parameters.jobNo = this.model.job.jobNo
        parameters.uuid = this.model.job.uuid
        parameters.documentType = cache.config.get('DefaultWarehousePhotoDocType') || 'warehouseIn'
        parameters.createdBy = this.user.userId
      }
      const dateCreated = this.getFormatDate()
      const ajaxResults = []
      for (const item of uploadRows) {
        const promise = uploadStorage(Object.assign({ file: item.file }, parameters)).then(res => {
          if (res.data) {
            item.documentId = res.data
            item.createdBy = this.user.userId
            item.dateCreated = dateCreated
          }
        })
        ajaxResults.push(promise)
      }
      this.uploading = true
      this.gridApi.refreshCells({ force: true })
      return Promise.all(ajaxResults).then(results => {
        const failCount = uploadRows.filter(p => p.todo === 'new' && !p.documentId).length
        if (failCount > 0) {
          this.$confirm(this.$t('queryJob.SuccessfullyPicturesAreYouSave', [uploadRows.length - failCount, failCount]), this.$t('common.tips.prompt'), {
            confirmButtonText: this.$t('common.btn.ok'),
            cancelButtonText: this.$t('common.btn.cancel'),
            type: 'warning',
            closeOnClickModal: false
          }).then(() => {
            this.$emit('uploadDone')
          }).catch(() => { })
        } else {
          this.$emit('uploadDone')
        }
      }).finally(() => {
        this.model.business_Document = [...this.model.business_Document]
        this.uploading = false
      })
    },
    getFormatDate() {
      return moment().format('YYYY-MM-DD HH:mm:ss')
    },
    submit() {
      const saveRows = this.model.business_Document.filter(p => p.todo === 'new' || p.todo === 'edit')
      const removeRows = this.model.business_Document.filter(p => p.todo === 'remove' && p.uuid)
      return Promise.all([
        ...Array.from(saveRows, p => saveBusinessDocument(p)),
        ...Array.from(removeRows, p => delBusinessDocument(p.uuid))
      ])
    },
    getSelectedFiles() {
      return this.gridApi.getSelectedRows()
    }
  }
}
</script>
